<template>
<div>
    <div v-if="confirmAlert">
      <transition name="fade">
      <div class="delete-alert-confirmation">
        <div class="alert-area">
            <div class="md:py-6  md:p-8  md:px-30 bg-white" id="delete-alert-confirmation-overlay">
                <div class="text-center pt-8 md:pt-0 login-selection-header pb-4">
                    Are you sure you want to <br class="md:hidden"/> delete this? 
                </div>
                <div class="flex delete-confirm-alert-content sm:pb-8 lg:pb-0 w-full items-center justify-center">
                    <div class="flex pr-2">
                    <a @click="deleteAddress(address_id_token)" class="new-app-btn cursor-pointer bg-blue mt-6 sm:mt-0 pr-4">
                        Yes
                    </a>
                    </div>
                    <div class="flex pl-2 ">
                    <a @click="confirmAlert = false,  selectAddressdeleted()" class="new-app-btn cursor-pointer bg-theme mt-6 sm:mt-0 ">
                        No
                    </a>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </transition>
    </div> 
    <div class="md:flex flex-wrap mb-8  justify-between address-selection">
      <button
        v-if="!userAddresses.length"
        type="button"
        class="bg-white border border-dark-b rounded-lg flex items-center justify-center py-32 px-20"
        @click="showAddressModal = true, isEditing = false"
      >
        <div class="leading-8 text-blue font-medium text-xl p-3">
          <p>+</p><p>Add New</p><p>Address</p>
        </div>
      </button>
      <template v-if="userAddresses.length">
        <div class="py-7.5 grid md:grid-cols-2 gap-4 xl:gap-7 lg:w-2/3">
          <div
            v-for="(address, index) in userAddresses"
            :key="`my-address-${index}`"
            class="px-7.5 py-10 bg-white border rounded-lg cursor-pointer"
            :class="selectedAddressId === address.id_token ? 'border border-green shadow-lg bg-green-light' : 'border-dark-b'"
            @click="selectAddress(address.id_token)"
          >
            <div class="radio-parent-class" v-if="selectedAddressId === address.id_token">
              <img class="radio-class" src="@/assets/images/green-checked.png" alt="">
            </div>
            <div class="radio-parent-class" v-else>
              <img class="radio-class" src="@/assets/images/green-uncheck.png" alt="">
            </div>
            <AddressBox  @edit="editAddress"
          @delete="deleteAddressConfirmation" :isSelected='selectedAddressId === address.id_token ? true : false' :address="address" :allowActions="true"/>
          </div>
        </div>
        <div class="md:w-full lg:w-content lg:text-right text-center lg:pt-10 pt-4 pb-4 lg:justify-self-end">
          <button
            class="rounded-full w-auto h-12 px-2 bg-dark-blue text-white text-xl font-medium"
            type="button"
            @click="showAddressModal = true, isEditing = false"

          >
            Add New Address
          </button>
        </div>
      </template>
      <AddressFormModal :isEditing="isEditing" @selectNewAddress="selectNewAddress"
      :address="addressToEdit" v-if="showAddressModal" @close="closeModal" />
    </div>
</div>
   
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AddressBox from '@/shared/components/profile/address/AddressBox'
import AddressFormModal from '@/shared/components/profile/address/AddressFormModal'
import ProductDetails from '@/shared/mixins/ProductDetails'

export default {
  name: 'AddressSeclection',
  mixins: [ ProductDetails ],
  props: {
    prevSelectedAddress: {
      type: Number,
      default: null
    },
    isUserAvailable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddressBox,
    AddressFormModal
  },
  data() {
    return {
      showAddressModal: false,
      userAddresses: [],
      selectedAddressId: null,
      addressToEdit: null,
      isEditing: false,
      address_id_token : '',
      confirmAlert: false,
    }
  },
  async mounted() {
    this.selectedAddressId = this.prevSelectedAddress
    this.userAddresses = await this.fetchBuyerAddresses()
    this.$emit('isAddressAvailable', this.userAddresses.length > 0 ? true : false)
    if (this.prevSelectedAddress && !this.userAddresses.some(address => address.id_token === this.selectedAddressId)) {
      this.selectedAddressId = null
      this.$emit('updateSelectedAddress', this.selectedAddressId)
    } else {
      if(this.userAddresses.length > 0 && !this.isUserAvailable) {
        this.selectAddress(this.userAddresses[0].id_token)
      }
    }

    const isFound = this.userAddresses.some(element => {
      if (element.id_token === this.selectedAddressId) {
        return true;
      }
      return false;
    });
    if(!isFound && this.userAddresses.length > 0) {
      this.selectAddress(this.userAddresses[0].id_token)
    }
  },
  computed: {
    ...mapGetters ([
      'getUserAuthInfo'
    ]),
  },
  watch: {
    userAddresses() {
      this.$emit('isAddressAvailable', this.userAddresses.length > 0 ? true : false)
    } 
  },
  methods: {
    ...mapActions ([
      'fetchBuyerAddresses',
      'deleteBuyerAddress'
    ]),
    selectNewAddress(id_token) {
      this.selectAddressAfterUpdate(id_token)
    },
    editAddress(address) {
      this.addressToEdit = {...address}
      this.isEditing = true
      this.showAddressModal = true
    },
    deleteAddressConfirmation(address) {
      this.address_id_token = address.id_token
      this.confirmAlert = true
    },
    async deleteAddress(id_token) {
      this.confirmAlert = false
      const response = await this.deleteBuyerAddress(id_token)
      if(response.result) {
        const pos = this.userAddresses.map(e => e.id_token).indexOf(this.address_id_token);
        this.userAddresses.splice(pos,1);
        if(id_token === this.selectedAddressId && this.userAddresses.length > 0)  { // if selected card was deleted & array of cards is not empty, then set new card
          this.selectAddress(this.userAddresses[0].id_token)
        }
        if((this.selectedAddressId == null || this.selectedAddressId == '') && this.userAddresses.length > 0) { // if card selection is not there & card's array is not empty then select new card
          this.selectAddress(this.userAddresses[0].id_token)
        }
        this.$emit('isAddressAvailable', this.userAddresses.length > 0 ? true : false)
        if(this.userAddresses.length == 0) { // if card length is 0, unselect the card using empty string
          this.selectAddress(null)
        }
      }

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    async closeModal (data) {
      this.showAddressModal = false
      if (data) this.userAddresses = await this.fetchBuyerAddresses()
    },
    selectAddress (id) {
      if (this.selectedAddressId === id) {
        this.selectedAddressId = null
        this.$emit('updateSelectedAddress', this.selectedAddressId)
      } else {
        this.selectedAddressId = id
        this.$emit('updateSelectedAddress', this.selectedAddressId)
      }
    },
    selectAddressAfterUpdate (id) {
      this.selectedAddressId = id
      this.$emit('updateSelectedAddress', this.selectedAddressId)
    },
    selectAddressdeleted() {
      let token = this.prevSelectedAddress != null ? this.prevSelectedAddress : this.address_id_token
      this.$emit('updateSelectedAddress', token)
      // this.selectAddress(token) 
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-parent-class {
  position: relative;
  /* padding: 1em; */
}
.radio-parent-class .radio-class {
  position: absolute;
  right: -18px;
  top: -26px;

}

address-remove-parent {
  position: relative;
}
.address-remove-parent .address-remove {
  position: absolute;
  right: 12px;
  top: 25px;

}
  .address-selection {
    .address-box-lg {
      @apply p-6 border-2 rounded-lg cursor-pointer bg-white;
    }
    .address-box {
      @apply p-6 border-2 rounded-lg cursor-pointer bg-white;
    }
    .selected {
      @apply border-green shadow-lg;
    }
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
.new-app-btn {
  @apply rounded-full px-4 py-2 text-white;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
}
.delete-alert-confirmation {
    justify-content: center;
    align-items: center;
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          content: "";
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
  .delete-confirm-alert-content {
  @media (max-width: 768px) {
    padding-bottom : 2rem;
  }
}
.login-selection-header {
    display: flex;
    justify-content: center;
    font-family: 'Avenir LT Pro';
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}
#delete-alert-confirmation-overlay {
  @media (max-width: 768px) {
    /* width: 150%; */
    // padding-left: 3rem;
    // padding-right: 3rem;
  width: 70%; 
  }
  margin: 1em auto;
  position: relative;
  color: #024457;
  z-index: 1001;
  border-radius: 8px;
}
</style>